define('SearchSpring.Mapper.Facets', [
    'underscore'
], function SearchSpringMapperFacets(
    _
) {
    return function mapFacets(data) {
        var newData = {};
        _.extend(newData, data, {
            id: data.field,
            url: data.field,
            values: _.map(data.values, function eachValue(origValue) {
                return _.extend(origValue, {
                    url: origValue.label
                });
            })
        });
        return newData;
    };
});

/*
{
active: false
count: 5786
label: "Item"
type: "value"
value: "Item"
} */
/*
id: "custitem_cseg_aws_country"
url: "custitem_cseg_aws_country"
values: [{url: "France", label: "France"}, {url: "Italy", label: "Italy"},…]
0: {url: "France", label: "France"}
 */
